<div class="container p-2 bg-white rounded event-container">
  <div class="product-content">
    <!-- Info Bar -->
    <div id="info-bar" class="mb-5">
      <div class="info-bar-header">
        {{productObject['productName']}}
      </div>
      <div class="info-bar-body">
        <div class="row mx-0 align-items-center">
          <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <div class="info-bar-title">{{ 'Buyer.HostedBy' | translate }}</div>
            <div class="info-bar-value">
              <a target="_blank" routerLink="/{{businessObject?.name}}">
                <div class="text-white">{{businessObject?.name}}</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Description -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.Description' | translate }}</div>
      <div class="payment-card-body">
        <app-read-more textValue="{{ description ? description : 'Buyer.NoDescription' | translate }}">
        </app-read-more>
      </div>
    </div>

    <!-- Product Tickets -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.Packages' | translate }}</div>
      <div class="payment-card-body">
        <div id="TicketExample" *ngFor="let package of packageList">
          <div class="row align-items-center rounded mx-4 mx-lg-0 Ticket">

            <div class="col-lg-5 col-xl-5 p-3 TicketLeft">
              <div class="fs-6 mb-2 font-weight-bold">{{package?.packageName}}</div>
              <hr class="TicketSidesSeparator" />
            </div>

            <div class="col-lg-7 col-xl-7 text-center p-3 TicketRight">
              <div class="row align-items-baseline">
                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 mt-4 mt-lg-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Period' | translate }}</div>
                  <div style="font-size: .8rem;">{{package?.period}} {{package?.durationType}}</div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-4 mt-lg-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Price' | translate }}</div>
                  <div style="font-size: .8rem;">
                    {{
                      vpihs
                        .getExchangedValue(
                          package?.price,
                          getNewProductValueByFieldName(
                            "currency",
                            "ProductExtraInfos"
                          )
                        )
                        .toFixed(2)
                    }}
                    {{
                      getNewProductValueByFieldName(
                        "currency",
                        "ProductExtraInfos"
                      )
                    }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mt-4 mt-lg-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Select' | translate }}</div>
                  <div class="form-check d-flex justify-content-center">
                    <input class="form-check-input" type="radio" id='regular' name="package" (click)="onPackageChoice(package)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>

    <!-- Ads -->
    <div class="mb-4">
      <!--<app-ads [productObject]="productObject"></app-ads>-->
    </div>

    <div class="row justify-content-end">
      <div class="col-lg-4 col-md-6 row">
        <button class="btn btn-primary" type="button" [disabled]="!packageChoice" (click)="proceedToPayment()">{{ 'Buyer.Next' | translate }}</button>
      </div>
    </div>
  </div>

</div>
